"use client";

import { useEffect, useState } from "react";
import { SidebarMenuItem } from "@/components/ui/sidebar";

/** Keep the slot mounted so both arrival and departure animate its space. */
export function AnimatedRailItem({
  visible,
  children,
}: {
  visible: boolean;
  children: React.ReactNode;
}) {
  const [expanded, setExpanded] = useState(false);
  useEffect(() => {
    if (!visible) {
      setExpanded(false);
      return;
    }
    let secondFrame = 0;
    // Commit the collapsed position before opening, including warm mounts.
    const firstFrame = requestAnimationFrame(() => {
      secondFrame = requestAnimationFrame(() => setExpanded(true));
    });
    return () => {
      cancelAnimationFrame(firstFrame);
      cancelAnimationFrame(secondFrame);
    };
  }, [visible]);
  const open = visible && expanded;
  return (
    <SidebarMenuItem
      aria-hidden={!open}
      inert={!open}
      className={`grid w-full overflow-hidden transition-[grid-template-rows,opacity] duration-300 ease-in-out motion-reduce:transition-none ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
    >
      <div className="min-h-0 overflow-hidden">
        <div className="flex justify-center pb-1">{children}</div>
      </div>
    </SidebarMenuItem>
  );
}
